import { Col, Row } from "reactstrap";
import { numberToGermanLocaleWithThousandSeperator } from "../helper/formatting-helper";
import React from "react";
import stringUtils from "../_helpers/string-utils";
import { DocumentLineItem } from "../_components/DocumentLineItem";
import { determineAdditionalInformationLinesForLineItem } from "../_helpers/AdditionalInformationHelper";

export const CreditNoteTransactions = ({ transactions, locale }) => {
    if (!transactions || transactions.length === 0) {
        return <></>;
    }

    return (
        <Row id="credit-note-transactions">
            <Col>
                <table className="table">
                    <tbody>
                    {transactions.map((transaction, index) => {
                        return (
                            <tr key={index}>
                                {!transaction.failed &&
                                    <td>
                                        {locale.REFUND_HAS_BEEN_PAID.replace(
                                            "$VALUE",
                                            numberToGermanLocaleWithThousandSeperator(transaction.amount) +
                                            transaction.currency,
                                        )}
                                    </td>
                                }
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const CreditNoteOrderAdjustments = ({ orderAdjustments, currencyCode, color, locale }) => {
    if (!orderAdjustments || orderAdjustments.length === 0) {
        return <></>;
    }

    return (
        <Row id="credit-note-order-adjustments">
            <Col>
                <h5 style={{
                    marginBottom: "5px",
                    fontSize: "0.9rem",
                }}>{locale.OTHER_CREDIT_NOTES}</h5>
                <table className="table">
                    <thead>
                    <tr>
                        <th style={{ color: color }}>{locale.REASON}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.TAX_ABBREVIATED}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.TAX_AMOUNT}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.SPLIT_AMOUNT}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.TOTAL}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orderAdjustments.map((adjustment, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    {adjustment.description
                                        ? adjustment.description
                                            .replace(
                                                "${OTHER_CREDIT_NOTES}",
                                                locale.OTHER_CREDIT_NOTES,
                                            ).replace(
                                                "${DELIVERY_COST}",
                                                locale.DELIVERY_COST,
                                            )
                                            .replace(
                                                "${REFUND_SHIPPING_COST}",
                                                locale.REFUND_SHIPPING_COST,
                                            )
                                        : ""}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {adjustment.taxLines &&
                                        adjustment.taxLines.map((taxLine, index) => {
                                            return (
                                                <div key={index}>
                                                    {taxLine.taxRatePercentageString}
                                                    <br />
                                                </div>
                                            );
                                        })}
                                </td>

                                <td style={{ textAlign: "right" }}>
                                    {adjustment.taxLines &&
                                        adjustment.taxLines.map((taxLine, index) => {
                                            return (
                                                <div key={index}>
                                                    {taxLine.mockItem
                                                        ? "*"
                                                        : numberToGermanLocaleWithThousandSeperator(
                                                        taxLine.taxAmount) + currencyCode
                                                    }
                                                    <br />
                                                </div>
                                            );
                                        })}
                                </td>

                                <td style={{ textAlign: "right" }}>
                                    {adjustment.taxLines &&
                                        adjustment.taxLines.map((taxLine, index) => {
                                            return (
                                                <div key={index}>
                                                    {numberToGermanLocaleWithThousandSeperator(
                                                        taxLine.amount,
                                                    )}
                                                    {currencyCode}
                                                    <br />
                                                </div>
                                            );
                                        })}
                                </td>

                                <td style={{ textAlign: "right" }}>
                                    {numberToGermanLocaleWithThousandSeperator(
                                        (adjustment.taxAmount && !adjustment.includesTaxes)
                                            ? adjustment.amount + adjustment.taxAmount
                                            : adjustment.amount,
                                    )}
                                    {currencyCode}
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const CreditNoteLineItems = ({
                                        lineItems,
                                        additionalInformationLines,
                                        currencyCode,
                                        hasDiscount,
                                        color,
                                        locale,
                                    }) => {
    if (!lineItems || lineItems.length === 0) {
        return <></>;
    }

    return (
        <Row id="credit-note-line-items">
            <Col>
                <h5 style={{
                    marginBottom: "5px",
                    fontSize: "0.9rem",
                }}>{locale.CREDIT_NOTES_LINE_ITEMS_TITLE}</h5>
                <table className="table table-borderless"
                       style={{ marginBottom: "0px", padding: ".1rem .1rem" }}>
                    <thead>
                    <tr>
                        <th style={{ color: color }}>{locale.PRODUCT}</th>
                        <th style={{ color: color }}>{locale.PRODUCT_DESCRIPTION}</th>
                        <th style={{ color: color }}>{locale.PRODUCT_AMOUNT}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.PRODUCT_SINGLE_PRICE}</th>
                        {hasDiscount && (
                            <th style={{ textAlign: "right", color: color }}>{locale.DISCOUNT}</th>
                        )}
                        <th style={{ textAlign: "right", color: color }}>{locale.TAX_ABBREVIATED}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.TAX_AMOUNT}</th>
                        <th style={{ textAlign: "right", color: color }}>{locale.TOTAL}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {lineItems.map((lineItem, index) => {
                        return (
                            <DocumentLineItem
                                key={index}
                                lineItem={lineItem}
                                currencyCode={currencyCode}
                                showDiscount={hasDiscount}
                                additionalInformationLineItems={determineAdditionalInformationLinesForLineItem(
                                    lineItem,
                                    additionalInformationLines,
                                )}
                                color={index % 2 === 0 ? "#F2F2F2" : "white"}
                                locale={locale}
                            />
                        );
                    })}
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const CreditNoteTotalBox = ({ creditNote, color, locale }) => {
    return (
        <Row id="total-box">
            <Col className="col-6"></Col>
            <Col className="col-6">
                <table className="table">
                    <tbody>
                    {(creditNote.totalAmountWithoutTax && (!creditNote.taxLines || creditNote.taxLines.length <= 1)) &&
                        <tr>
                            <td>{locale.TOTAL_EXCLUDING_VAT}</td>
                            <td style={{ textAlign: "right" }}>
                                {creditNote.totalAmountWithoutTax
                                    ? numberToGermanLocaleWithThousandSeperator(
                                        creditNote.totalAmountWithoutTax,
                                    )
                                    : "0,00"}
                                {creditNote.currencyCode}
                            </td>
                        </tr>
                    }

                    {creditNote.taxLines && creditNote.taxLines.length > 1 &&
                        creditNote.taxLines.map((taxLine, index) => {
                            let vatDescription = taxLine.vatDescription
                                ? "(" + taxLine.vatDescription + ") "
                                : "";
                            return (
                                <tr key={index}>
                                    <td>
                                        {locale.TOTAL_EXCLUDING_VAT +
                                            "(" +
                                            vatDescription +
                                            taxLine.taxRatePercentageString +
                                            ")"}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {taxLine.amount
                                            ? numberToGermanLocaleWithThousandSeperator(Number(taxLine.amount) - Number(taxLine.taxAmount))
                                            : "0,00"}
                                        {creditNote.currencyCode}
                                    </td>
                                </tr>
                            );
                        })}

                    {creditNote.taxLines &&
                        creditNote.taxLines.map((taxLine, index) => {
                            let vatDescription = taxLine.vatDescription
                                ? "(" + taxLine.vatDescription + ") "
                                : "";
                            return (
                                <tr key={index}>
                                    <td>
                                        {locale.TAX_ABBREVIATED +
                                            " " +
                                            vatDescription +
                                            taxLine.taxRatePercentageString}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {taxLine.mockItem
                                            ? "*"
                                            : (taxLine.taxAmount
                                            ? numberToGermanLocaleWithThousandSeperator(taxLine.taxAmount)
                                            : "0,00") + creditNote.currencyCode
                                        }
                                    </td>
                                </tr>
                            );
                        })}

                    {creditNote.totalAmount !== creditNote.totalAmountWithoutTax &&
                        <tr
                            style={{
                                fontWeight: "bold",
                            }}
                        >
                            <td style={{ color: color }}>{locale.TOTAL_INCLUDING_VAT}</td>
                            <td style={{ textAlign: "right", color: color }}>
                                {numberToGermanLocaleWithThousandSeperator(creditNote.totalAmount)}
                                {creditNote.currencyCode}
                            </td>
                        </tr>
                    }

                    </tbody>
                </table>
            </Col>
        </Row>
    );
};

export const CreditNoteNumber = ({ creditNoteNumber, isReversalDocument, isDummy, testMode, color, locale }) => {
    return (
        <Row className="py-4">
            <Col className="col-12">
                <h4
                    style={{
                        display: "inline",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        color: color,
                    }}
                >
                    {isReversalDocument
                        && locale.REVERSAL_CREDIT_NOTE + " #" + creditNoteNumber + "-Storno"}

                    {!isReversalDocument &&
                        locale.CREDIT_NOTE + " " + ((isDummy || testMode)
                            ? "#Muster"
                            : creditNoteNumber
                                ? "#" + creditNoteNumber
                                : "")}
                </h4>
                <br />
                {isReversalDocument &&
                    <h4 style={{
                        display: "inline",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        color: color,
                    }}>
                        {"Zu " + locale.CREDIT_NOTE + " " + ((isDummy || testMode)
                            ? "#Muster"
                            : creditNoteNumber
                                ? "#" + creditNoteNumber
                                : "")}
                    </h4>
                }
            </Col>
        </Row>
    );
};

export const BasicCreditNoteInformationBox = ({ creditNote, creditNoteDate, showCreditNoteText, locale }) => {
    return (
        <Row id="payment">
            <Col className="col-6">
                <Row>
                    <Col className="col-6">
                        <b>{locale.ORDER_NUMBER}:</b>
                    </Col>
                    <Col className="col-6">{creditNote.orderName}</Col>
                </Row>
                {!stringUtils.isBlank(creditNote.paymentMethod) && <Row>
                    <Col className="col-6">
                        <b>{locale.PAYMENT_METHOD}:</b>
                    </Col>
                    <Col className="col-6">{creditNote.paymentMethod}</Col>
                </Row>
                }
                {showCreditNoteText && (
                    <Row>
                        <Col className="col-6">
                            <b>{locale.NOTE}:</b>
                        </Col>
                        <Col className="col-6">{creditNote.reason}</Col>
                    </Row>
                )}
            </Col>

            <Col className="col-6">
                <Row>
                    <Col className="col-6">
                        <b>{locale.CREATION_DATE}:</b>
                    </Col>
                    <Col className="col-6">{creditNoteDate}</Col>
                </Row>
                <Row>
                    <Col className="col-6"></Col>
                    <Col className="col-6"></Col>
                </Row>
            </Col>
        </Row>
    );
};